import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div id={{this.getDestinationId}} ...attributes></div>")